<template>
  <div class="language">
    <router-link :to="{ name: this.$route.name, params: { language: 'es', category: this.$route.params.category}, query: getQuery }" active-class="active">ES</router-link> - 
    <router-link :to="{ name: this.$route.name, params: { language: 'ca', category: this.$route.params.category}, query: getQuery }" active-class="active">CA</router-link>
<!--     <router-link :to="{ name: this.$route.name, params: { language: 'ca', category: 'indice' }, query: getQuery }" active-class="active">CA</router-link>
 -->  </div>
</template>

<i18n>
{
  "es": {
  },
  "en": {
    "": ""  
  },
  "ca": {
    "": ""
  }
}
</i18n>

<script>
  import { mapGetters } from 'vuex'

  import MenuRedesSociales from './MenuRedesSociales.vue'

	export default {
    components: { MenuRedesSociales },
		data: () => {
			return{
			}
    },
    computed: {
      ...mapGetters(['getQuery']), 
    } 
  }
</script>
